import { MapPin, Users, CalendarDays, BadgeCheck } from "lucide-react";
import { PageHeader } from "../components/PageHeader";
import { CTASection } from "../components/CTASection";
import { Reveal } from "../components/Reveal";
import { PROJECTS } from "../data/content";

const statusColor = (s) =>
  s === "Ongoing" ? "bg-emerald-50 text-emerald-800 border-emerald-200" : "bg-blue-50 text-blue-800 border-blue-200";

export default function Projects() {
  return (
    <main data-testid="projects-page">
      <PageHeader
        title="Our Projects"
        subtitle="Documented, measurable projects bringing healthcare and opportunity to communities across Assam."
      />
      <section className="py-16 sm:py-20 bg-white">
        <div className="container-hecso grid grid-cols-1 md:grid-cols-2 gap-8">
          {PROJECTS.map((p, i) => (
            <Reveal key={p.title} delay={(i % 2) * 100}>
              <div className="h-full rounded-xl border border-slate-200 bg-white overflow-hidden shadow-sm transition-shadow hover:shadow-md" data-testid={`project-detail-${i}`}>
                <div className="relative h-60 overflow-hidden group">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  <span className={`absolute top-4 right-4 rounded-full border px-3 py-1 text-xs font-semibold ${statusColor(p.status)}`}>
                    {p.status}
                  </span>
                </div>
                <div className="p-7">
                  <h2 className="font-heading text-xl font-semibold text-hecso-ink">{p.title}</h2>
                  <p className="mt-3 text-sm sm:text-base text-hecso-muted leading-relaxed">{p.description}</p>
                  <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {[
                      { icon: MapPin, label: "Location", value: p.location },
                      { icon: Users, label: "Beneficiaries", value: p.beneficiaries },
                      { icon: CalendarDays, label: "Project Year", value: p.year },
                      { icon: BadgeCheck, label: "Status", value: p.status },
                    ].map((m) => (
                      <div key={m.label} className="flex items-center gap-3 rounded-lg bg-hecso-beige px-4 py-3">
                        <m.icon className="w-4 h-4 shrink-0 text-hecso-green" />
                        <div>
                          <p className="text-[11px] uppercase tracking-wide text-hecso-muted">{m.label}</p>
                          <p className="text-sm font-semibold text-hecso-ink">{m.value}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTASection />
    </main>
  );
}
